import { render, staticRenderFns } from "./ShowContent.vue?vue&type=template&id=68448e54&"
import script from "./ShowContent.vue?vue&type=script&lang=js&"
export * from "./ShowContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports